export const SelfReportedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="reported">
      <path id="Vector" d="M8.375 6H6.5C5.67157 6 5 6.67157 5 7.5V18C5 18.8284 5.67157 19.5 6.5 19.5H11" stroke="white"
            stroke-opacity="0.5" stroke-width="1.125" stroke-linecap="round" />
      <path id="Vector_2" d="M13.625 6H15.5C16.3284 6 17 6.67157 17 7.5V14.25" stroke="white" stroke-opacity="0.5"
            stroke-width="1.125" stroke-linecap="round" />
      <path id="Vector_3"
            d="M8 7.8V6.375C8 6.16789 8.16789 6 8.375 6C8.58211 6 8.75317 5.83203 8.78864 5.62798C8.89976 4.98878 9.33049 3.75 11 3.75C12.6695 3.75 13.1002 4.98878 13.2114 5.62798C13.2468 5.83203 13.4179 6 13.625 6C13.8321 6 14 6.16789 14 6.375V7.8C14 8.04853 13.7985 8.25 13.55 8.25H8.45C8.20147 8.25 8 8.04853 8 7.8Z"
            stroke="white" stroke-opacity="0.5" stroke-width="1.125" stroke-linecap="round" />
      <path id="Vector_4" d="M13.625 18.375L15.125 19.875L18.875 16.125" stroke="white" stroke-opacity="0.5"
            stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
    </g>
  </svg>
);